import { Clock } from 'lucide-react';
import ShareButton from '../components/ShareButton';
import { C } from '../constants';
import Glass from '../components/Glass';

export default function ResultsPendingScreen({ stateData, userVote }) {
  const { partyById, localFont, strings, accent } = stateData;
  const p = userVote ? partyById[userVote.party] : null;

  return (
    <main className="px-5 md:px-10 py-10 max-w-3xl mx-auto">
      {/* Thank-you ribbon */}
      {p && (
        <Glass style={{
          padding:     '1.1rem 1.3rem',
          marginBottom:'2rem',
          border:      `1px solid ${p.color}55`,
          boxShadow:   `0 0 32px ${p.color}25`,
          animation:   'tnpoll-fadeup 600ms cubic-bezier(0.175, 0.885, 0.32, 1.275)',
        }}>
          <div className="flex items-center gap-3 flex-wrap">
            <div className="flex-1 min-w-0">
              <div style={{ fontWeight: 700, fontSize: '1.05rem', color: C.white }}>
                Thank you for voting. You are a responsible citizen.
              </div>
              <div style={{ fontFamily: localFont, fontSize: '0.86rem', color: C.textDim, marginTop: 2 }}>
                {strings.thankYou}
              </div>
            </div>
            <span style={{
              fontSize:        '0.66rem',
              letterSpacing:   '0.16em',
              textTransform:   'uppercase',
              color:           C.white,
              backgroundColor: p.color,
              padding:         '5px 11px',
              fontWeight:      700,
              borderRadius:    999,
              boxShadow:       `0 0 16px ${p.color}88`,
            }}>
              Voted {p.en}
            </span>
          </div>
        </Glass>
      )}

      <div style={{ textAlign: 'center', paddingTop: '2rem' }}>
        <Clock size={48} color={accent} style={{ margin: '0 auto', filter: `drop-shadow(0 0 12px ${accent})` }} />

        <h2 style={{
          fontWeight: 700, fontSize: 'clamp(1.8rem, 4vw, 2.6rem)',
          lineHeight: 1.1, letterSpacing: '-0.02em',
          marginTop: '1.2rem', color: C.white,
        }}>
          Results coming soon
        </h2>

        <p style={{ fontFamily: localFont, fontSize: '1rem', color: C.textDim, marginTop: '0.5rem' }}>
          {strings.resultsPending}
        </p>

        <p style={{ color: C.textDim, fontSize: '0.9rem', marginTop: '1.5rem', lineHeight: 1.6, maxWidth: 480, margin: '1.5rem auto 0' }}>
          Votes are being counted. The admin will publish the live results shortly.
          Check back here — the page will update automatically.
        </p>

        <div className="mt-8">
          <ShareButton stateId={stateData.id} stateName={stateData.name} accent={accent} />
        </div>
      </div>
    </main>
  );
}
